<template>
  <!-- 行按钮操作pop -->
  <el-popover
    :ref="refName"
    v-model="visible"
    :placement="placement"
    :offset="offset"
    :width="width"
    :content="content"
    :trigger="trigger"
    :disabled="isDisable"
  >
    <slot name="contentHtml">
      <p>{{ $t(confirmMessage) }}</p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" @click="visible = false;">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" size="mini" @click="visible = false;buttonClickEvent();">{{ $t("button.confirm") }}</el-button>
      </div>
    </slot>
    <slot slot="reference" name="button" />
  </el-popover>
</template>

<script>
export default {
  components: {},
  props: {
    width: { type: Number, default: 160 },
    placement: { type: String, default: 'top' },
    offset: { type: Number, default: 0 },
    isConfirm: { type: Boolean, default: false },
    refName: { type: String },
    content: String,
    trigger: { type: String, default: 'click' },
    buttonClick: Function,
    rowIndex: Number,
    rowData: Object,
    confirmMessage: { type: String, default: 'messageCommon.confirmDelete' },
    isDisable: { type: Boolean, default: false }//是否禁用
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // console.log(this.rowIndex)
    //  console.log(this.$refs[ this.refName])
  },
  methods: {
    buttonClickEvent() {
      this.$emit('button-click-event')
    }
  }
}
</script>
<style  scoped>
</style>
